module.exports = __webpack_public_path__ + "static/media/loudspeaker alt.1402c059.png";